import { useState, ReactNode, CSSProperties, MouseEvent } from 'react'
import styles from './style'

interface TouchableOpacityProps {
  children?: ReactNode
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  onRightClick?: (() => void) | null
  style?: CSSProperties
  onMouseOver?: (() => void) | null
  onMouseOut?: (() => void) | null
  hoverable?: boolean
  disabled?: boolean
}

function TouchableOpacity({
  children,
  onClick = () => {},
  onRightClick = null,
  style = {},
  onMouseOver = null,
  onMouseOut = null,
  hoverable = false,
  disabled = false,
}: TouchableOpacityProps) {
  const [isMouseDown, setIsMouseDown] = useState(false)
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseOut={() => {
        setHovered(false)
        onMouseOut && onMouseOut()
      }}
      onMouseOver={() => {
        setHovered(true)
        onMouseOver && onMouseOver()
      }}
      onClick={e => {
        if (disabled) return
        setIsMouseDown(false)
        onClick(e)
      }}
      onMouseDown={() => {
        setIsMouseDown(true)
      }}
      onContextMenu={evt => {
        if (disabled) return
        if (onRightClick) {
          evt.preventDefault()
          onRightClick()
        }
        setIsMouseDown(false)
      }}
      style={{
        ...style,
        ...styles.base,
        opacity: isMouseDown || disabled ? 0.5 : 1,
        ...(hovered && hoverable ? styles.hovered : {}),
      }}
    >
      {children}
    </div>
  )
}

export default TouchableOpacity
